import { Reducer } from "redux";

export interface USPState {
  Header?: string;
  Text?: string;
  IsEnabled?: boolean;
}

type USPStateType = USPState | null | undefined;
// for dev. purposes
const defaults: USPStateType = null;

export const reducer: Reducer<USPStateType> = (state: USPStateType = defaults): USPStateType => {
  return state;
};

export const actions = {};
